import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { InvestmentProvider } from './context/InvestmentContext';
import ToastContainer from './components/Toast';
import RootLayout from './pages/RootLayout';
import Investments from './pages/Investments';
import Customers from './pages/Customers';
import Payments from './pages/Payments';
import Invoices from './pages/Invoices';
import ChangeRequests from './pages/ChangeRequests';
// import Revolution from './pages/Revolution'; // removed
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

const router = createBrowserRouter(
  [
          {
          path: '/login',
          element: <LoginPage />,
        },
          {
          path: '/forgot-password',
          element: <ForgotPasswordPage />,
        },
          {
          path: '/reset-password',
          element: <ResetPasswordPage />,
        },
    {
      path: '/',
      element: <RootLayout />,
      children: [
        {
          // Wejscie na goly adres przerzuca od razu na /investments.
          //
          // Celowo stala sciezka, a nie getDefaultPage() z AuthContext: ta funkcja
          // dla nieznanej roli zwraca '/', co dalo by petle przekierowan. Rola bez
          // dostepu do /investments (np. accountant) i tak zostanie stamtad
          // przeniesiona na swoja strone domyslna - pilnuje tego RootLayout przez
          // canAccess(), wiec nie duplikujemy tu logiki uprawnien.
          index: true,
          element: <Navigate to="/investments" replace />,
        },
        {
          path: '/investments',
          element: <Investments />,
        },
        {
          path: '/customers',
          element: <Customers />,
        },
        {
          path: '/payments',
          element: <Payments />,
        },
        {
          path: '/invoices',
          element: <Invoices />,
        },
        {
          path: '/change-requests',
          element: <ChangeRequests />,
        },
      ],
    },
  ],
);

const App = () => {
  return (
    <ToastProvider>
      <InvestmentProvider>
        <AuthProvider>
          <RouterProvider router={router} />
          <ToastContainer />
        </AuthProvider>
      </InvestmentProvider>
    </ToastProvider>
  );
};

export default App;
